import { render, staticRenderFns } from "./PrevisaoDemanda.vue?vue&type=template&id=560fa6c6&scoped=true&"
import script from "./PrevisaoDemanda.vue?vue&type=script&lang=js&"
export * from "./PrevisaoDemanda.vue?vue&type=script&lang=js&"
import style0 from "./PrevisaoDemanda.vue?vue&type=style&index=0&id=560fa6c6&prod&scoped=true&lang=css&"
import style1 from "./PrevisaoDemanda.vue?vue&type=style&index=1&id=560fa6c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560fa6c6",
  null
  
)

export default component.exports